import { preventIEError } from '@neux/ui-jquery/tool';
import '@neux/ui-jquery/neux-ui-jquery';
import scrollUpShowHeader from './scrollUpShowHeader.js';
import mobileMenu from './mobileMenu.js';
import { getData } from './util.js';

function initializePage() {
  getData('location', 'POST', renderData, JSON.stringify({ is_home: true, sort: 'ADDRESS' }));
}

function main() {
  // init
  preventIEError();
  initializePage();
  // for api
  scrollUpShowHeader();
  mobileMenu();
}

function renderData(data) {
  // 整理回傳的資料
  let organizeDataList = organizeData(data);
  // tab__nav
  let tabNavTemplateHTML = tabNavTemplate(organizeDataList);
  // tab__content
  let tabContentTemplateHTML = tabContentTemplate(organizeDataList);
  $('#location-tab').append(tabNavTemplateHTML, tabContentTemplateHTML);
  // 渲染後動作
  additionFn();
}

function organizeData(data) {
  let organizeData = [{
    type: 'all',
    name: '全部',
    datas: data.datas
  }];

  // 創建類別
  $.each(data.types, function (index, item) {
    let arr = {
      type: item.type_id,
      name: item.name,
      datas: []
    }
    organizeData.push(arr);
  });

  // 資料塞入對應類別
  $.each(data.datas, function (index, item) {
    // 撈出對應的object
    const arr = organizeData.filter((data) => {
      return data.type === item.type_id
    });

    // 塞入對應資料
		if(arr[0]?.hasOwnProperty('datas')) {
			arr[0]['datas'].push(item);
		}
  });

  return organizeData;
}

function tabNavTemplate(data) {
  let outerText = '<div class="tab__nav">';

  $.each(data, function (index, item) {
    outerText += `
    <div class="tab__link" refer-to="#tab__box${index + 1}" data-quantity="${item.datas.length}" tabindex="0">${item.name}</div>
    `;
  });

  outerText += '</div>';

  return outerText;
}

function tabContentTemplate(data) {
  let outputText = '<div class="tab__content">';

  $.each(data, function (index, item) {
    outputText += `
    <div id="tab__box${index + 1}" class="tab-content__box">
      <table class="location-table">
        <thead>
          <tr>
            <th class="location-table__th">名稱</th>
            <th class="location-table__th">地址</th>
            <th class="location-table__th">電話</th>
          </tr>
        </thead>
        <tbody>
    `;
    $.each(item.datas, function (index, trData) {
      outputText += `
      <tr class="location-table__tr">
        <td class="location-table__td">${trData.name}</td>
        <td class="location-table__td">${trData.city + trData.zip_code + trData.address}</td>
        <td class="location-table__td"><a href="tel:${trData.tel}" title="${trData.tel}"
            class="location-table__link">${trData.tel}</a>
        </td>
      </tr>
      `;
    });

    outputText += `
        </tbody>
      </table>
    </div>
    `;
  });

  outputText += `</tbody>`;
  outputText += '</div>';
  return outputText;
}

function additionFn() {
  $('.tab').nxJqTab({
    navSelector: '.tab__nav',//填入所使用的導覽列class或選擇器
    containerSelector: '.tab__content'//填入所使用的內容容器class或選擇器
  });
  $('.tab__link').on('keydown', function (e) {
    if (e.keyCode === 13) {
      $(this).trigger('click');
    }
  });
}

main();